import {updateScroll} from "../utilities/locootiveScroll";

export default function collapse() {

    if ($('.v-builder__elements--collapse').length > 0) {

        const $collapse = {
            item: '.c-collapse__item',
            btn: $('.c-collapse__item--btn'),
            content: '.c-collapse__item--content',
            active_class: 'js-isActive'
        }

        $collapse.btn.click(function () {

            const $container = $(this).closest($collapse.item);
            const $close_btn = $(this).find('.close');

            $container.each(function () {
                if (!$(this).hasClass('js-isActive')) {
                    $('.c-collapse__item').removeClass('js-isActive');
                    $('.c-collapse__item .close').removeClass('js-isActive');
                    $('.c-collapse__item--content').slideUp(400, function () {
                        updateScroll();
                    });
                    $collapse.btn.removeClass($collapse.active_class);
                }
            });

            if (!$container.hasClass($collapse.active_class)) {
                $container.addClass($collapse.active_class);
                $(this).next($collapse.content).slideDown(400, function () {
                    updateScroll();
                });
                $(this).find('.close').addClass($collapse.active_class);
            } else {
                $container.removeClass($collapse.active_class);
                $(this).next($collapse.content).slideUp(400, function () {
                    updateScroll();
                });
                $(this).find('.close').removeClass($collapse.active_class);
            }
        })
    }
}

collapse();
